angular.module('mean.databases').filter('numberFixedLen', function () {
    function stringIsNumber(s) {
        var x = +s; // made cast obvious for demonstration
        return x.toString() === s;
    };

    return function (n, len) {
        if(stringIsNumber(n)) {
            var num = parseInt(n, 10);
            len = parseInt(len, 10);
            if (isNaN(num) || isNaN(len)) {
                return n;
            }
            num = ''+num;
            while (num.length < len) {
                num = '0'+num;
            }
            return num;
        } else {
            return n;
        }
    };
});


// WEBPACK FOOTER //
// ./packages/custom/databases/public/filters/number-fixed-len.js